import './Login.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';
import './index.css';

import React, { Component } from 'react';
import {FormGroup, FormControl, ControlLabel, Image, Modal} from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import Menu from './Menu.js';

import axios from 'axios';

import { properties } from './properties.js';
import * as Auth from './AuthService';

require('promise.prototype.finally').shim();

class Reset extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            triedToSubmit: false
        }
    }

    checkRequired(value) {
        return (value.length === 0 && this.state.triedToSubmit) ? 'error' : null;
    }

    handleSubmit(e){
        e.preventDefault();
        if(this.state.email.length > 0) {
            axios.get(`${properties.apiUrl}/api/password-change-request?email=${this.state.email}&type=short&request=create`, {})
                .then((json) => {
                    alert('New password was sent to ' + this.state.email);
                    this.props.onClose()
                })
                .catch(error => alert(error.response.data))
                .finally(() => this.setState({
                    triedToSubmit: false
                }));
        } else {
            alert('Email is empty!')
        }
    }

    render() {
        return(
            <Modal show onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Reset password</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className='row'>
                        <form onSubmit={e => this.handleSubmit(e)}>
                            <FormGroup controlId="email"
                                       validationState={this.checkRequired(this.state.email)}>
                                <div style={{marginLeft: 15}}>
                                    <ControlLabel>Email</ControlLabel>
                                </div>

                                <div className='col-md-9'>
                                    <FormControl type="email" value={this.state.email}
                                                 onChange={e => this.setState({email: e.target.value})}/>
                                </div>
                                <Button type="submit" bsStyle="primary" className='col-md-2' loading={this.state.submitInProgress} onClick={e => this.handleSubmit(e)}>Send e-mail</Button>
                            </FormGroup>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            triedToSubmit: false,
            submitInProgress: false,
            error: null,
            showModal: false
        };
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({triedToSubmit: true});
        if (this.state.email.length > 0 && this.state.password.length > 0) {
            this.setState({submitInProgress: true});
            axios.post(`${properties.apiUrl}/api/login`, {
                    'login': this.state.email,
                    'password': this.state.password,
                }, {withCredentials: true})
                .then(json => {
                    Auth.login(json.data.jwt, json.data.user);
                    this.props.history.replace(Auth.extractRedirect());
                })
                .catch(error => this.setState({error: error.response.data, submitInProgress: false}));
        }
    }

    checkRequired(value) {
        return (value.length === 0 && this.state.triedToSubmit) ? 'error' : null;
    }

    render() {
        return (
            <div className="Login-root center-block panel panel-primary">
                <Image src="/images/digatex.png"/>
                <form onSubmit={e => this.handleSubmit(e)}>
                    <FormGroup controlId="email"
                               validationState={this.checkRequired(this.state.email)}>
                        <ControlLabel>Login</ControlLabel>
                        <FormControl type="email" value={this.state.email}
                                     onChange={e => this.setState({email: e.target.value})}/>
                    </FormGroup>
                    <FormGroup controlId="password"
                               validationState={this.checkRequired(this.state.password)}>
                        <ControlLabel>Password</ControlLabel>
                        <FormControl type="password" value={this.state.password}
                                     onChange={e => this.setState({password: e.target.value})}/>
                    </FormGroup>
                    { this.state.error && <span className="text-danger">{this.state.error}</span> }
                    <Button
                        type="submit"
                        bsStyle="primary"
                        className="center-block"
                        style={{marginTop: "10px", width: "100%"}}
                        loading={this.state.submitInProgress}
                    >
                        Log In
                    </Button>

                    { Auth.getProviders().map(provider => (
                        <Button
                            key={provider.id}
                            bsStyle="default"
                            className="center-block"
                            style={{marginTop: "10px", width: "100%"}}
                            onClick={() => Auth.loginWithKeycloak(provider)}
                        >
                            {provider.label}
                        </Button>
                    ))}

                    <div style={{marginTop: 10, textAlign: "center"}}>
                        <a onClick={() => this.setState({showModal:true})}>Forget your password?</a>
                    </div>
                </form>
                <Menu history={this.props.history} logout={false}/>
                {this.state.showModal && <Reset onClose={(status) => this.setState({showModal: false})}/>}
            </div>
        );
    }
}

export default Login;